import React from 'react';
import { Check } from 'lucide-react';
const comparisonData = [{
  sit: 'Volviste a inflamarte a los 5 días',
  mega: 'Repetís el reseteo',
  jean: 'El rebote no ocurre'
}, {
  sit: 'Querés el jean flojo para siempre',
  mega: 'Alivio temporal',
  jean: 'Sistema de mantenimiento de por vida'
}, {
  sit: 'Sistema 30 días de reprogramación',
  mega: 'No incluido',
  jean: 'Protocolo 80/20 permanente'
}, {
  sit: 'Biohacks accesibles en Argentina',
  mega: 'No incluido',
  jean: 'Guía farmacia y dietética completa'
}, {
  sit: 'Sellado intestinal profundo',
  mega: 'No incluido',
  jean: 'Protocolo de permeabilidad completo'
}];
const jeanFlojoIncludes = ['Sistema completo de 30 días en 3 fases progresivas', 'Protocolo de sellado intestinal con alimentos argentinos', 'Receta del caldo criollo reparador de 24 horas', 'Guía de biohacking accesible — magnesio, vitamina D3, omega 3, cinc', 'Protocolo del vinagre de manzana para la ventana de glucosa', 'Kéfir casero — cómo hacerlo y usarlo desde cero', 'Calendario Jean Flojo de 30 días completo día a día', 'Tracker de métricas reales — jean, cara, energía, hinchazón', 'El protocolo 80/20 para vivir deshinchada de por vida'];
export function ComparisonTable() {
  return <section className="py-16 px-4 bg-black border-t border-white/5" data-id="element-44">
      <div className="max-w-4xl mx-auto" data-id="element-45">
        <div className="mb-10" data-id="element-46">
          <h2 className="text-2xl sm:text-3xl font-extrabold text-white flex items-center justify-center gap-3" data-id="element-47">
            <span data-id="element-48">🕊️</span> ¿QUÉ AGREGA EL EFECTO JEAN FLOJO?
          </h2>
        </div>

        <div className="bg-white/5 backdrop-blur-sm rounded-2xl shadow-md overflow-hidden mb-12 border border-white/10" data-id="element-49">
          <div className="overflow-x-auto" data-id="element-50">
            <table className="w-full text-left border-collapse" data-id="element-51">
              <thead data-id="element-52">
                <tr className="bg-brand-green text-white" data-id="element-53">
                  <th className="p-4 font-bold w-1/3 text-center" data-id="element-54">Situación</th>
                  <th className="p-4 font-bold w-1/3 text-center border-l border-white/20" data-id="element-55">
                    ❌ Solo MegaPack
                  </th>
                  <th className="p-4 font-bold w-1/3 text-center border-l border-white/20 bg-brand-green/90" data-id="element-56">
                    ✅ Con Jean Flojo
                  </th>
                </tr>
              </thead>
              <tbody data-id="element-57">
                {comparisonData.map((row, i) => <tr key={i} className={i % 2 === 0 ? 'bg-white/[0.02]' : ''} data-id="element-58">
                    <td className="p-4 text-sm font-medium text-gray-200 border-b border-white/5 text-center" data-id="element-59">
                      {row.sit}
                    </td>
                    <td className="p-4 text-sm text-center text-gray-400 border-l border-b border-white/5" data-id="element-60">
                      {row.mega}
                    </td>
                    <td className="p-4 text-sm font-bold text-brand-green text-center border-l border-b border-white/5 bg-brand-green/5" data-id="element-61">
                      {row.jean}
                    </td>
                  </tr>)}
              </tbody>
            </table>
          </div>
        </div>

        <div className="bg-white/5 backdrop-blur-sm rounded-2xl p-8 border border-brand-green/30" data-id="element-62">
          <h3 className="text-xl font-bold text-white mb-6 flex items-center justify-center gap-2" data-id="element-63">
            <Check className="text-brand-green" data-id="element-64" /> EL EFECTO JEAN FLOJO INCLUYE:
          </h3>
          <ul className="grid grid-cols-1 md:grid-cols-2 gap-y-4 gap-x-8" data-id="element-65">
            {jeanFlojoIncludes.map((item, i) => <li key={i} className="flex items-start gap-3 text-left" data-id="element-66">
                <div className="bg-brand-green/20 p-1 rounded-full shrink-0 mt-0.5" data-id="element-67">
                  <Check size={14} className="text-brand-green" strokeWidth={3} data-id="element-68" />
                </div>
                <span className="text-sm text-gray-200 font-medium leading-relaxed" data-id="element-69">
                  {item}
                </span>
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}